// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"179":"0c7cd784","263":"c3532684"}[chunkId] + ".chunk.css";
};